var map = {
	"./Dogs-marker-gray.svg": "1402",
	"./Dogs-marker.svg": "a182",
	"./Dox-walking-button-active.svg": "4760",
	"./Dox-walking-button-active_old.svg": "846b",
	"./Dox-walking-button-inactive.svg": "fca3",
	"./Dox-walking-icon-active.svg": "de11",
	"./Dox-walking-icon-inactive.svg": "8fdf",
	"./about/doxincircle.svg": "5cb5",
	"./about/fb.svg": "90ad",
	"./about/insta.svg": "d1ac",
	"./about/tiktok.svg": "8318",
	"./about/youtube.svg": "6b2b",
	"./add.svg": "876b",
	"./ai.svg": "628e",
	"./android.svg": "845d",
	"./apple.svg": "33f4",
	"./avatar-outline.svg": "8752",
	"./avatar.svg": "9d81",
	"./back.svg": "af81",
	"./cake.svg": "6102",
	"./call-invert.svg": "5270e",
	"./call.svg": "129c",
	"./camera.svg": "d24a",
	"./cat-dog.svg": "2e13",
	"./cat-head.svg": "c281",
	"./cat-white.svg": "9048",
	"./cat.svg": "9563",
	"./chat/send.svg": "eff0",
	"./check-gray.svg": "a1dd",
	"./check.svg": "e7d6",
	"./chevron-back-outline.svg": "ec85",
	"./chevron-forward-outline.svg": "cb2b",
	"./chip.svg": "7e0f",
	"./circle-close.svg": "0af6",
	"./circle-plus-black.svg": "44d8",
	"./circle-plus.svg": "67e0",
	"./circle-plus2.svg": "4bbc",
	"./circle_marker.svg": "2c4c",
	"./close-black.svg": "287e",
	"./close.svg": "0572",
	"./documents.svg": "d92c",
	"./dog-biscuit.svg": "7ac4",
	"./dog-head.svg": "5f5b",
	"./dog-white.svg": "511b",
	"./dog.svg": "4505",
	"./dox-gray.svg": "7a02",
	"./dox-label.svg": "5f8a",
	"./dox-pair.svg": "87e0",
	"./dox-red.svg": "812f",
	"./dox.svg": "d6a9",
	"./edit.svg": "c560",
	"./exclamation-circle.svg": "bec59",
	"./exclamation-gray.svg": "ce76",
	"./exclamation.svg": "2651",
	"./follow-outline.svg": "a156",
	"./follow.svg": "2bca",
	"./followed.svg": "9b98",
	"./forgot-password.svg": "9aea",
	"./health-book.svg": "af90",
	"./health.svg": "c075",
	"./home-gray.svg": "7c71",
	"./home.svg": "7936",
	"./info-circle.svg": "8341",
	"./info-full.svg": "7587",
	"./info-outline.svg": "0c8b",
	"./info.svg": "3e95",
	"./leaderboard/adventurer-gray.svg": "a5dc",
	"./leaderboard/explorer-gray.svg": "9fb3",
	"./leaderboard/newbie-gray.svg": "6184",
	"./like-outline.svg": "d019",
	"./location.svg": "c411",
	"./message-gray.svg": "501f",
	"./message.svg": "2931",
	"./notification.svg": "b17b",
	"./passport.svg": "6b25",
	"./password.svg": "2e14",
	"./pedigree.svg": "469c",
	"./pet/block-pet.svg": "693c",
	"./pet/blocked-icon.svg": "676f",
	"./pet/user-revoke.svg": "e709",
	"./petmenu_infoicon.svg": "f764",
	"./petmenu_settingsicon.svg": "b402",
	"./phone.svg": "a3f6",
	"./poi/bin.svg": "064a",
	"./poi/share.svg": "9f72",
	"./post/cat.svg": "e428",
	"./post/dog.svg": "19c2",
	"./post/poi.svg": "144c",
	"./post/search.svg": "492e",
	"./posticon.svg": "a980",
	"./present/404.svg": "d651",
	"./previous.svg": "4ac0",
	"./profile-user-gray.svg": "0d4f",
	"./profile-user-red-but-actually-gray.svg": "5cd4",
	"./profile-user-red.svg": "a6fb",
	"./refresh-page-option.svg": "6538",
	"./search-all.svg": "221a",
	"./search-follow.svg": "38aa",
	"./search-gray.svg": "196b",
	"./search-icon.svg": "b87a",
	"./search-local.svg": "a23c",
	"./search.svg": "f919",
	"./send.svg": "1460",
	"./seta.svg": "58fd",
	"./settings.svg": "e15e",
	"./szimat.svg": "5f5e",
	"./vaccination.svg": "aebb",
	"./vector.svg": "ffe2",
	"./walk/create-arrow.svg": "1df8",
	"./walk/dogbeach-marker.svg": "e527",
	"./walk/dogfriendly-marker.svg": "5d38",
	"./walk/event-active.svg": "84db",
	"./walk/event-inactive-marker.svg": "8ffe",
	"./walk/event-inactive.svg": "b950",
	"./walk/event-marker.svg": "b164",
	"./walk/event-not-reviewed-marker.svg": "9f88",
	"./walk/event.svg": "c3b7",
	"./walk/gift-easter.svg": "0cbd",
	"./walk/gift.svg": "03fa",
	"./walk/giftlost.svg": "8e47",
	"./walk/info.svg": "fd67",
	"./walk/mapcenter.svg": "89a6",
	"./walk/paw_green.svg": "81b9",
	"./walk/paw_grey.svg": "a71f",
	"./walk/poi/breeder.svg": "ee7e",
	"./walk/poi/dogfriendly.svg": "f832",
	"./walk/poi/email.svg": "d337",
	"./walk/poi/helpcare.svg": "1b3d",
	"./walk/poi/medical.svg": "2b21",
	"./walk/poi/phone.svg": "61a4",
	"./walk/poi/place.svg": "a25f",
	"./walk/poi/plus.svg": "a744",
	"./walk/poi/unknown.svg": "86bb",
	"./walk/poi/vendor.svg": "bd35",
	"./walk/poi/walkplace.svg": "eac0",
	"./walk/postplacebutton.svg": "77e6",
	"./walk/present/distance.svg": "9dba",
	"./walk/present/images.svg": "00fb",
	"./walk/present/qr.svg": "0453",
	"./walk/unknown-marker.svg": "a5e4",
	"./walk/unknown-normal.svg": "013d",
	"./walk/unknown-pink.svg": "7a2f",
	"./walk/walkplace-marker.svg": "6632",
	"./walkgray.svg": "bc2c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";